import React, { useEffect } from "react";
import Nav from "../components/layout/Nav";
import Footer from "../components/layout/Footer";
import Hero from "../components/sections/Hero";
import TrustBar from "../components/sections/TrustBar";
import Services from "../components/sections/Services";
import Why from "../components/sections/Why";
import References from "../components/sections/References";
import Workflow from "../components/sections/Workflow";
import About from "../components/sections/About";
import Testimonials from "../components/sections/Testimonials";
import CTA from "../components/sections/CTA";
import Contact from "../components/sections/Contact";
import useLenis from "../hooks/useLenis";

export default function Home() {
  useLenis();

  useEffect(() => {
    // Deep-link to hash if present
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <>
      <Nav />
      <main data-testid="home-main" id="hauptinhalt">
        <Hero />
        <TrustBar />
        <Services />
        <Why />
        <References />
        <Workflow />
        <About />
        <Testimonials />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
